var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { bound } from '../../../../utils/decorators/basic';
import { getEventClass } from '../../../event/getEventClass';
export class AspectEventReception {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectEvents() {
        return this.parent;
    }
    get aspect() {
        return this.aspectEvents.aspect;
    }
    handleReactEvent(reactEvent) {
        if (reactEvent.persist)
            reactEvent.persist();
        const EventClass = getEventClass(reactEvent.type);
        const event = new EventClass({
            rawEvent: reactEvent,
            aspect: this.aspect,
        });
        this.handleEvent(event);
    }
    async handleEvent(event) {
        const eventHandlers = this.aspect.global.aspectActive.activeTraits.filter(at => at.key === event.reg.handlerName);
        // fire handlers
        for (const at of eventHandlers) {
            await at.handleEvent(event);
        }
        const triggerProgrammaticHandlers = this.aspect.aspectEvents.programmaticListeners
            .filter(l => l[0] === event.reg.handlerName)
            .forEach(l => l[1](event));
        // record event
        this.aspectEvents.eventsOfType(event.type).unshift(event);
    }
}
__decorate([
    bound
], AspectEventReception.prototype, "handleReactEvent", null);
__decorate([
    action.bound
], AspectEventReception.prototype, "handleEvent", null);
